<template>
	<div>
		<!-- 第一列 -->
		<el-form class="left" ref="defForm" :disabled="true" :model="defForm" label-width="120px">
			<el-form-item label="姓名" prop="name">
				<el-input v-model="defForm.name"></el-input>
			</el-form-item>
			<el-form-item label="电话" prop="phone">
				<el-input v-model="defForm.phone"></el-input>
			</el-form-item>
		</el-form>
		<!-- 第二列 -->
		<el-form class="right" ref="defForm2" :disabled="true" :model="defForm" label-width="120px">
			<el-form-item label="邮箱" prop="email">
				<el-input v-model="defForm.email"></el-input>
			</el-form-item>
			<el-form-item label="城市" prop="city">
				<el-input v-model="defForm.city"></el-input>
			</el-form-item>
		</el-form>
		<!-- 编辑器 -->
		<el-form ref="defForm3" :disabled="true" :model="defForm" label-width="120px">
			<el-form-item label="留言内容" prop="content">
				<el-input v-model="defForm.content" :autosize="true" type="textarea"></el-input>
			</el-form-item>
		</el-form>
		<!-- 按钮部分 -->
		<div class="button" style="margin-left: 100px;">
			<el-button type="primary" @click="$router.back()">返回</el-button>
			<!-- <el-button type="primary" :loading="loading" @click="submitForm(defForm)">保存</el-button> -->
		</div>
	</div>
</template>
<script>
	import '@riophae/vue-treeselect/dist/vue-treeselect.css'
	import token from '@/token.js'
	export default {
		name: "Add",
		data() {
			return {
				defForm: {
					id:0,
					name: '',
					phone: '',
					email:'',
					city: '',
					publish: '',
					content: '',
					updateUserID: token.getUser().id,
					updateUserName: token.getUser().manager_username
				},
				treeData: [],
				loading: false,
			}
		},

		created() {
			let obj = this.$route.query.obj
			console.log(obj)
			this.defForm.id=obj.id,
			this.defForm.name=obj.name,
			this.defForm.phone=obj.phone,
			this.defForm.email=obj.email,
			this.defForm.city=obj.city,
			this.defForm.publish=obj.publish,
			this.defForm.content=obj.content==null ? '': obj.content;
		},
		methods: {
			close() {
				this.$emit("hideDialog")
			},
		}
	}
</script>

<style scoped>
	div /deep/ .el-date-editor{
		width: 100%;
	}
	div /deep/ .el-select{
		width: 100%;
	}
	.left{
		width: 50%;
		display: inline-block;
	}
	.right{
		width: 50%;
		display: inline-block;
	}
	.avatar-uploader {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		width: 80px;
		height: 80px;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 80px;
		height: 80px;
		line-height: 80px;
		text-align: center;
	}

	.avatar {
		width: 80px;
		height: 80px;
		display: block;
	}
</style>
